import {Component, Input} from '@angular/core';
import {KnownPlatform, PlatformService} from '../platform.service';
import {Platform} from '@uofu-uss-aux/software-catalog-ng-core';
import {PlatformIconComponent} from '../../svg/platform-icon/platform-icon.component';
import {svgSize} from '../../svg/svg.directive';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.scss'],
  standalone: true,
  imports: [
    PlatformIconComponent
  ]
})
export class PlatformComponent {

  name = '';
  knownPlatform = KnownPlatform.web;
  @Input()
  size?: svgSize;
  constructor(private readonly platformService: PlatformService) {
  }

  @Input() set platform(platform: Platform) {
    this.knownPlatform = this.platformService.findPlatform(platform);
    this.name = platform?.title;
  }

}
